import React, { useContext, useEffect } from 'react';
import { withStyles } from '@mui/styles';
import { observer } from 'mobx-react-lite';
import { withRouter } from 'react-router-dom';
import Container from '@mui/material/Container';
import Layout from 'components/layout';
import AssessmentList from 'components/assessments_pages/AssessmentList';
import InnerHeader from 'components/layout/InnerHeader';

import CreateNewAssessment from 'components/assessments_pages/CreateNewAssessment';
import * as qs from 'query-string';
import { AssessmentQueryCtx } from 'components/assessments_pages/AssessmentList/queryStore';
import OnboardingDialog from 'pages/onboarding/onboarding_dialog';
import { FilterCtx } from './filter-store';
import MarketplaceSearchField from './MarketplaceSearchField';

import styles from './styles';
import FilterBar from './FilterBar';

const Marketplace = observer(({ classes, company, location, history }) => {
    const { handleFilter } = useContext(FilterCtx);
    const { setQuery } = useContext(AssessmentQueryCtx);
    const parsed = qs.parse(location.search);

    useEffect(() => {
        if (parsed.assessmentName) {
            setQuery('');
            handleFilter('query', parsed.assessmentName);
        }
    }, []);

    const removeOnboardingDialog = () => {
        history.push('/marketplace');
    };

    return (
        <Layout>
            <InnerHeader
                header="Assessment Library"
                className={classes.wrapper}
                rightPart={(
                    <div className={classes.boxWrapper}>
                        <MarketplaceSearchField
                            wrapClass={classes.wrapClass}
                            className={classes.searchField}
                            handleFilter={handleFilter}
                        />
                        <CreateNewAssessment
                            buttonLabel="New Assessment"
                        />
                    </div>
                )}
            />
            <Container disableGutters>
                <div className={classes.wrapBox}>
                    <FilterBar />
                    <div className={classes.assessmentListWrap}>
                        {
                            parsed.redirectFrom === 'onboarding' && (
                                <OnboardingDialog
                                    open
                                    onClose={removeOnboardingDialog}
                                >
                                    We loved showing you around Vervoe! Ready to pick your next simulation & invite up to 5 real candidates or colleagues? Let's do this <span role="img" aria-label="!">🚀</span>
                                </OnboardingDialog>
                            )
                        }
                        <AssessmentList
                            company={company}
                            publicAssessments
                        />
                    </div>
                </div>
            </Container>
        </Layout>
    );
});

export default withRouter(withStyles(styles)(Marketplace));
